import { ClassifiedAdsUnreadBadge } from "@/features/classified-ads/components/ClassifiedAdsUnreadBadge";
import { useClassifiedAdUnreadCounts } from "@/features/classified-ads/hooks/useClassifiedAdUnreadCounts";

export const ClassifiedAdsMenuBadge = () => {
  const { totalUnreadRooms } = useClassifiedAdUnreadCounts();

  return <ClassifiedAdsUnreadBadge count={totalUnreadRooms} testId="classified-ads-menu-unread-total" />;
};

ClassifiedAdsMenuBadge.displayName = "ClassifiedAdsMenuBadge";
